import { router } from '@/router/index.js'

export default ({

/** 
* @param {String} path  이동할 경로
* @param {Object} params 이동할 화면에 넘겨줄 파라미터
*/
routerPush(path,params){
    if(params != '' && params != null && params != undefined ){
        router.push({
            path : path,
            state : params
        })

    }else{
        router.push({ path: path })
    }
},

/** 
* @param {Array} keys 가져올 key,value
* @return {Object} 
*/
getParams(keys){
    let obj = history.state
    let params = {}

    for(let key of keys){
        params[key] = obj[key]     
    }

    return params
},

goBack(){
    router.go(-1)
}


});